import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../components/layout/SimpleHeader';
import WriteMessage from '../../components/sms/send/WriteMessage';

const SmsSend: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content scrollbar">
      <SimpleHeader
        iconFile="icon-sms-big.svg"
        parentMenu={t('common.menu.text')}
        currentMenu={t('sms.send.title1')}
      />
      <WriteMessage />
    </div>
  );
};

export default SmsSend;
